import { defineComponent as _defineComponent } from 'vue'
import { navigateToMap } from '@@/bits/location'
import { getPostPublishedAt } from '@@/bits/post_timestamps'
import { anonymous, blankUser, isRegistered } from '@@/bits/user_model'
import OzAvatar from '@@/library/v4/components/OzAvatar.vue'
import OzDivider, { OzDividerColorScheme } from '@@/library/v4/components/OzDivider.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import OzRelativeTime from '@@/library/v4/components/OzRelativeTime.vue'
import { useDarkModeStore } from '@@/pinia/dark_mode'
import { useExpandedPostStore } from '@@/pinia/expanded_post'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfacePostPropertiesStore } from '@@/pinia/surface_post_properties'
import { useReactionsStore } from '@@/pinia/surface_reactions'
import { useSurfaceSectionsStore } from '@@/pinia/surface_sections'
import { useSurfaceUserContributorsStore } from '@@/pinia/surface_user_contributors'
import { useSurfaceWishArrangementStore } from '@@/pinia/surface_wish_arrangement'
import { useWindowSizeStore } from '@@/pinia/window_size'
import type { Id } from '@@/types'
import SurfacePanelPostExpandedTextPanelComments from '@@/vuecomponents/SurfacePanelPostExpandedTextPanelComments.vue'
import SurfacePostBody from '@@/vuecomponents/SurfacePostBody.vue'
import SurfacePostProperties from '@@/vuecomponents/SurfacePostProperties.vue'
import SurfacePostSocialContentTopBar from '@@/vuecomponents/SurfacePostSocialContentTopBar.vue'
import { storeToRefs } from 'pinia'
import { computed, withDefaults } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePanelPostExpandedTextPanel',
  props: {
    attachmentCaption: { default: '' },
    reactionIdsByPostId: { default: () => ({}) },
    commentIdsByPostId: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { attachmentCaption: string, reactionIdsByPostId: Record<Id, Id[]>, commentIdsByPostId: Record<Id, Id[]> }



const surfaceStore = useSurfaceStore()
const darkModeStore = useDarkModeStore()
const windowSizeStore = useWindowSizeStore()
const surfacePostPropertiesStore = useSurfacePostPropertiesStore()
const surfacePermissionsStore = useSurfacePermissionsStore()
const reactionsStore = useReactionsStore()
const expandedPostStore = useExpandedPostStore()
const surfaceSectionsStore = useSurfaceSectionsStore()
const surfaceWishArrangementStore = useSurfaceWishArrangementStore()
const surfaceUserContributorStore = useSurfaceUserContributorsStore()

const { expandedPost, expandedPostId } = storeToRefs(expandedPostStore)
const { isMap, xAuthor, title } = storeToRefs(surfaceStore)
const { isDarkMode } = storeToRefs(darkModeStore)
const { isSmallerThanDesktop } = storeToRefs(windowSizeStore)
const { isReactable, isCommentable } = storeToRefs(surfacePermissionsStore)
const { wallCustomPostProperties, isLocationEnabled } = storeToRefs(surfacePostPropertiesStore)

const xPostProperties = computed(() =>
  expandedPost.value ? surfacePostPropertiesStore.shouldShowPostProperties(expandedPost.value) : false,
)
const section = computed(() => {
  if (!surfaceWishArrangementStore.isSectionable) {
    return null
  }
  return expandedPost.value?.wall_section_id
    ? surfaceSectionsStore.getSectionById(expandedPost.value.wall_section_id)
    : null
})
const author = computed(() => {
  if (!expandedPost.value?.author_id) {
    return blankUser()
  }
  return (
    surfaceUserContributorStore.getUserById(expandedPost.value.author_hashid || expandedPost.value.author_id) ||
    blankUser()
  )
})
const isAuthorRegistered = computed(() => isRegistered(author.value))
const authorName = computed(() => (isAuthorRegistered.value ? author.value.name || author.value.username : anonymous))
const postBody = computed(() => expandedPost.value?.body)
const xDivider = computed(
  () =>
    xAuthor.value ||
    !!expandedPost.value?.subject ||
    !!postBody.value ||
    !!expandedPost.value?.location_name ||
    !!section.value ||
    !!props.attachmentCaption,
)
const commentCount = computed(() =>
  expandedPostId.value ? props.commentIdsByPostId[expandedPostId.value]?.length || 0 : 0,
)
const publishedAt = computed(() => (expandedPost.value ? getPostPublishedAt(expandedPost.value) : ''))
const xReactions = computed(
  () =>
    (isReactable.value ||
      (expandedPostId.value ? props.reactionIdsByPostId[expandedPostId.value]?.length > 0 : false)) &&
    !!reactionsStore.originalReactionData,
)
const xComments = computed(
  () => expandedPost.value?.published === true && (isCommentable.value || commentCount.value > 0),
)

const openInMap = () => {
  if (!expandedPost.value?.location_point) return
  navigateToMap({
    lat: expandedPost.value.location_point.latitude,
    lng: expandedPost.value.location_point.longitude,
    name: expandedPost.value.location_name || '',
  })
}

return { __sfc: true,props, surfaceStore, darkModeStore, windowSizeStore, surfacePostPropertiesStore, surfacePermissionsStore, reactionsStore, expandedPostStore, surfaceSectionsStore, surfaceWishArrangementStore, surfaceUserContributorStore, expandedPost, expandedPostId, isMap, xAuthor, title, isDarkMode, isSmallerThanDesktop, isReactable, isCommentable, wallCustomPostProperties, isLocationEnabled, xPostProperties, section, author, isAuthorRegistered, authorName, postBody, xDivider, commentCount, publishedAt, xReactions, xComments, openInMap, OzAvatar, OzDivider, OzDividerColorScheme, OzIcon, OzRelativeTime, SurfacePanelPostExpandedTextPanelComments, SurfacePostBody, SurfacePostProperties, SurfacePostSocialContentTopBar }
}

})